module.exports = __webpack_public_path__ + "lp/img/mystage_logo@2x.a3c20838.png";